module.exports = "/images/ru.svg";